import { useState } from "react"
import { makeStyles } from "tss-react/mui"
import { IconButton, Tooltip } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleQuestion } from "@fortawesome/pro-light-svg-icons"
import { HelpDialog } from "../../components/dialogs/helpDialog/HelpDialog"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    iconColor: {
        color: theme.palette.tailwind.neutral[500],
    },
}))
export function HelpNavItem() {
    const { classes } = useStyles()
    const [dialogState, setDialogState] = useState(false)

    function handleClick() {
        setDialogState((prev) => !prev)
    }

    return (
        <>
            <LocalizedStrict id="help-tooltip-text" attrs={{ title: true }}>
                <Tooltip title="Show help">
                    <IconButton onClick={handleClick} size="medium">
                        <FontAwesomeIcon icon={faCircleQuestion} className={classes.iconColor} />
                    </IconButton>
                </Tooltip>
            </LocalizedStrict>
            {dialogState && <HelpDialog dialogState={dialogState} setDialogState={setDialogState} />}
        </>
    )
}
